import React, { useState } from "react"

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

const cardCls =
  "rounded-xl border border-red-200 dark:border-red-900/50 bg-red-50/50 dark:bg-red-950/20 p-4 sm:p-6"
const dangerBtn =
  "inline-flex items-center justify-center rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
const ghostBtn =
  "inline-flex items-center justify-center rounded-lg border border-gray-300 dark:border-gray-700 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
const inputCls =
  "block w-full rounded-lg border border-gray-300 dark:border-gray-700 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
const labelCls = "block text-sm font-medium text-gray-700 dark:text-gray-300"

// A destructive form that posts a real (non-XHR) DELETE so the server can
// redirect + reset the session. Hidden _method + CSRF mirror Rails' button_to.
function ConfirmForm({ action, children, submitLabel, submitDisabled, onCancel }) {
  return (
    <form method="post" action={action} className="mt-4 space-y-4">
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" value={csrfToken()} />
      {children}
      <div className="flex flex-wrap gap-3">
        <button type="submit" disabled={submitDisabled} className={dangerBtn}>
          {submitLabel}
        </button>
        <button type="button" onClick={onCancel} className={ghostBtn}>
          {copyCancel()}
        </button>
      </div>
    </form>
  )
}

let _cancel = "Cancel"
const copyCancel = () => _cancel

export function DangerZone({ isOwner, partnerName, userAccountPath, partnerAccountPath, copy }) {
  _cancel = copy.cancel
  const [openPartner, setOpenPartner] = useState(false)
  const [openAccount, setOpenAccount] = useState(false)
  const [confirmName, setConfirmName] = useState("")

  return (
    <section className="space-y-6">
      <h2 className="text-lg font-semibold text-red-700 dark:text-red-400">{copy.title}</h2>

      {isOwner && (
        <div className={cardCls}>
          <h3 className="font-semibold text-gray-900 dark:text-gray-100">{copy.partner.heading}</h3>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{copy.partner.body}</p>
          {!openPartner ? (
            <button type="button" onClick={() => setOpenPartner(true)} className={`mt-4 ${dangerBtn}`}>
              {copy.partner.button}
            </button>
          ) : (
            <ConfirmForm
              action={partnerAccountPath}
              submitLabel={copy.partner.confirmButton}
              submitDisabled={confirmName !== partnerName}
              onCancel={() => { setOpenPartner(false); setConfirmName("") }}
            >
              <div>
                <label className={labelCls}>
                  {copy.partner.confirmLabel}{" "}
                  <code className="rounded bg-gray-100 dark:bg-gray-800 px-1 font-mono">{partnerName}</code>
                </label>
                <input
                  type="text"
                  name="confirm"
                  value={confirmName}
                  onChange={(e) => setConfirmName(e.target.value)}
                  autoComplete="off"
                  className={`mt-1 ${inputCls}`}
                />
              </div>
            </ConfirmForm>
          )}
        </div>
      )}

      <div className={cardCls}>
        <h3 className="font-semibold text-gray-900 dark:text-gray-100">{copy.account.heading}</h3>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{copy.account.body}</p>
        {!openAccount ? (
          <button type="button" onClick={() => setOpenAccount(true)} className={`mt-4 ${dangerBtn}`}>
            {copy.account.button}
          </button>
        ) : (
          <ConfirmForm
            action={userAccountPath}
            submitLabel={copy.account.confirmButton}
            submitDisabled={false}
            onCancel={() => setOpenAccount(false)}
          >
            <div>
              <label className={labelCls}>{copy.account.passwordLabel}</label>
              <input
                type="password"
                name="current_password"
                required
                autoComplete="current-password"
                className={`mt-1 ${inputCls}`}
              />
            </div>
          </ConfirmForm>
        )}
      </div>
    </section>
  )
}
